export default __webpack_public_path__ + "static/media/img--interiors-6.2f483532.jpg";